import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import deepEquals from 'Lib/Object/deepEquals';
import { isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import BsCompactionMould from './CompactionMould';

const CompactionMouldSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, prefixName }) => {
  const dispatch = useDispatch();
  const moulds = useSelector(createWorksheetSelector!('Equipment.Moulds.Moulds'), deepEquals) as any[];

  const updateMoulds = (value: any[]) => {
    dispatch(
      actions.setValue({
        name: prefixName!('Equipment.Moulds.Moulds'),
        value: value,
        sync: true,
      })
    );
  };

  const dissabledMouldOptions = moulds.filter((mould) => !isNil(mould.Mould)).map((mould) => mould.Mould.Id);

  const addMould = () => updateMoulds([...moulds, {}]);
  const removeMould = (index: number) => updateMoulds(removeElementByIndex(moulds, index));

  const getHeading = (index: number) => `Mould ${moulds.length === 1 ? '' : index + 1} Internal Dimensions & Masses`;

  return (
    <>
      {moulds.map((_, index) => (
        <ListFieldSection key={index} heading={getHeading(index)} wide>
          <BsCompactionMould
            onRemoveMouldClick={() => removeMould(index)}
            onAddMouldClick={addMould}
            name={`Equipment.Moulds.Moulds[${index}]`}
            removeMouldVisible={moulds.length > 1}
            addMouldVisible={index === moulds.length - 1}
            disabledMouldOptions={dissabledMouldOptions}
          />
        </ListFieldSection>
      ))}
    </>
  );
};

const removeElementByIndex = (elements: any[], index: number) => {
  var res = [...elements];

  res.splice(index, 1);

  return res;
};

const BsCompactionMouldSection = withInjectedProps(CompactionMouldSection);

export { BsCompactionMouldSection };
export default BsCompactionMouldSection;
